module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner-wedding-movie@3x-8f5d87f1e69ca3ae4981b2ee5020f28c.webp";